import { render } from "./GlobalTabBar.vue?vue&type=template&id=47a800e3"
import script from "./GlobalTabBar.vue?vue&type=script&lang=js"
export * from "./GlobalTabBar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\jhj\\applemarket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__